module.exports = __webpack_public_path__ + "static/6-e48fbe5b190a5a104e07f4b687aacca5.jpg";